<template>

    <v-card :color="settings.surveyBoxColor">
        <v-card-text class="mr-0">

            <!-- EDIT MODE-->
            <div v-if="editMode" class="text-left">
                <notification-preferences-widget
                    :data="notificationsModel"
                    :translations="translations"
                ></notification-preferences-widget>

                <div class="d-flex justify-space-between mt-4">
                    <text-editor
                        v-model="saveButtonTextModel"
                        hint="Confirm save notification preference button text"
                    >
                        <v-btn
                            :color="settings.actionButtonColor"
                            :dark="isDarkColor(settings.actionButtonColor)"
                        >
                            {{ saveButtonText }}
                        </v-btn>
                    </text-editor>

                    <text-editor
                        v-model="closeAccountButtonTextModel"
                        hint="Confirm close account button text"
                    >
                        <v-btn
                            :color="settings.actionButtonColor"
                            :dark="isDarkColor(settings.actionButtonColor)"
                        >
                            {{ closeAccountButtonText }}
                        </v-btn>
                    </text-editor>
                </div>
            </div>

            <!-- RENDER MODE-->
            <div v-else class="text-left">
                <notification-preferences-widget
                    v-model="notificationsModel"
                    :translations="translations"
                ></notification-preferences-widget>

                <div class="d-flex justify-space-between mt-4">
                    <v-btn :loading="saving"
                           :color="settings.actionButtonColor"
                           :dark="isDarkColor(settings.actionButtonColor)"
                           @click="saveNotifications"
                    >
                        {{ saveButtonText }}
                    </v-btn>

                    <v-btn :loading="saving"
                           :color="settings.actionButtonColor"
                           :dark="isDarkColor(settings.actionButtonColor)"
                           @click="closeAccount"
                    >
                        {{ closeAccountButtonText }}
                    </v-btn>
                </div>
            </div>

        </v-card-text>
    </v-card>

</template>

<script>

import TextEditor from "@/components/UI/TextEditor.vue";
import colorMixin from "@/components/mixins/colorMixin.js";
import Api from "@/api.js";
import NotificationPreferencesWidget from "@/components/UI/NotificationPreferencesWidget.vue";

export default {
    mixins: [
        colorMixin,
    ],

    components: {
        TextEditor,
        NotificationPreferencesWidget,
    },

    props: {
        saveButtonText: {
            type: String,
            required: true,
        },
        closeAccountButtonText: {
            type: String,
            required: true,
        },
        settings: {
            type: Object,
            required: true,
        },
        locale: {
            type: Object,
            required: true,
        },
        notificationPreferences: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
        translations: {
            type: Object,
            required: true,
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        subPanelId: {
            type: Number,
            required: false,
            default: null,
        },
        unsubscribeUrl: {
            type: String | null,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            saving: false,
            notifications: [],
        }
    },

    computed: {
        notificationsModel: {
            get() {
                if (this.notifications.length) {
                    return this.notifications;
                }

                return this.notifications = this.notificationPreferences;
            },
            set(value) {
                this.notifications = value;
            }
        },

        saveButtonTextModel: {
            get() {
                return this.saveButtonText;
            },
            set(value) {
                this.$emit('change:subPanelTranslations', {notification_preferences_save_button: value});
            }
        },

        closeAccountButtonTextModel: {
            get() {
                return this.closeAccountButtonText;
            },
            set(value) {
                this.$emit('change:subPanelTranslations', {notification_preferences_close_account_button: value});
            }
        },
    },

    methods: {
        saveNotifications() {
            this.saving = true;

            Api.put(this.unsubscribeUrl, {data: this.notificationsModel})
                .then(() => {
                    this.sendToUrl('/landing-page/notification-pref-changed/' + this.subPanelId + '/' + this.locale.code);
                })
                .catch(error => {
                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: 'Oops! That failed please try again later!'
                    });
                });
        },

        closeAccount() {
            this.saving = true;

            if (!this.unsubscribeUrl) {
                console.error('unsubscribe-url not defined!');
                this.saving = false;

                return;
            }

            this.sendToUrl(this.unsubscribeUrl);
        }
    },
}
</script>
